module.exports = __webpack_public_path__ + "static/media/dedicated_services.b8ce83ca.svg";